import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import globals from '#utilities/js/ea/globals.js'
import { audioStates, getAudioState } from '../audio.js'
import { mute } from '../action_x.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: () => {
    globals.ea_rainbow_videoswitch()
    if (getAudioState() === audioStates.mute) {
      setTimeout(mute, 500)
    }
  }
})

export default button => {
  onClick.listen(button)
}
